export const diagnosticIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The Diagnostic Results report is where you can view your students\' Diagnostic results. This report provides insight into the extent to which students have developed automatic word recognition sufficient to support fluency. The Diagnostic is scored on a 600 point scale. Students complete a Pre (Before Unit 1), Mid (After Unit 12), and Post Diagnostic (After Unit 24) during their time using the WordFlight System. The Diagnostic is rigorous and usually takes 3-4 sessions to complete.'
  },
  {
    element: '.filter-options',
    intro: 'Use these filters to narrow down the students by grade or class.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Diagnostic Results for the selected Test Type(s).'
  },
  {
    element: '.width-20:first-child',
    intro: 'Select the test type from the dropdown. The dropdown will include the specific Diagnostic test type once one student has completed it: Pre, Mid, and Post Diagnostic.'
  },
  {
    element: '#compare-checkbox',
    intro: 'Compare results between the Diagnostic test types by selecting a test type from the dropdown. Track student progress from one Diagnostic assessment to the next.'
  },
  {
    element: '.zone-explanation',
    intro: 'See the instructional zone descriptions. The descriptions include decoding knowledge and automatic word recognition.'
  },
  {
    element: '.report-chart-wrapper',
    intro: 'These charts show the number of students in each of the three risk categories identified by the WordFlight Diagnostic. Some Risk and High Risk students are recommended as excellent candidates for WordFlight. Minimally proficient students may also benefit from using WordFlight.'
  },
  {
    element: '#student-data-table',
    intro: 'Click the top of any column to sort the column.'
  },
  {
    element: '#student-data-table th:nth-child(2)',
    intro: 'See each student’s name.'
  },
  {
    element: '#student-data-table th:nth-child(3)',
    intro: 'See each student’s grade.'
  },
  {
    element: '#student-data-table th:nth-child(4)',
    intro: 'See each student’s word recognition score. This score is on a 600 point scale.'
  },
  {
    element: '#decodingHeader',
    intro: 'See each student’s decoding score. This score is on a 600 point scale. Only students in grades 5 and above will have a decoding score.'
  },
  {
    element: '#instructionalZoneHeader',
    intro: 'See each student’s instructional zone (Zones 1-4). Students are sorted into one of four instructional zones following each Diagnostic (Pre, Mid, Post). This information is needed for teacher-facilitated small groups. Group students by zone.'
  },
  {
    element: '#testTypeHeader',
    intro: 'See the student’s test type (Pre, Mid, or Post Diagnostic).'
  },
  {
    element: '#dateCompletedHeader',
    intro: 'See the date each student completed the specified Diagnostic.'
  }
];